"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanFetchError = exports.isFetchError = exports.isFetchResponse = void 0;
const isFetchResponse = (value) => {
    return (Boolean(value) &&
        typeof value === "object" &&
        value !== null &&
        typeof value.status === "number" &&
        typeof value.statusText === "string" &&
        typeof value.ok === "boolean" &&
        typeof value.url === "string" &&
        typeof value.headers === "object" &&
        typeof value.clone === "function" &&
        typeof value.json === "function" &&
        typeof value.text === "function");
};
exports.isFetchResponse = isFetchResponse;
const isFetchError = (error) => {
    return (error instanceof TypeError &&
        (error.message.includes("fetch") ||
            error.message.includes("network") ||
            error.message.includes("Failed to fetch")));
};
exports.isFetchError = isFetchError;
const cleanFetchError = async (error) => {
    // Handle Response objects that aren't errors but might be logged as errors
    if ((0, exports.isFetchResponse)(error)) {
        const headersRecord = {};
        error.headers.forEach((value, key) => {
            headersRecord[key] = value;
        });
        let responseData;
        try {
            const contentType = error.headers.get("content-type");
            if (contentType?.includes("application/json")) {
                responseData = await error.clone().json();
            }
            else {
                responseData = await error.clone().text();
            }
        }
        catch {
            responseData = "[Unable to parse response data]";
        }
        return {
            errorMessage: `HTTP ${error.status}: ${error.statusText}`,
            errorCode: error.status.toString(),
            responseData,
            responseStatus: error.status,
            responseHeaders: headersRecord,
        };
    }
    // Handle network errors (TypeError)
    if ((0, exports.isFetchError)(error)) {
        return {
            errorMessage: error.message,
            errorCode: "NETWORK_ERROR",
        };
    }
    return error;
};
exports.cleanFetchError = cleanFetchError;
//# sourceMappingURL=Fetch.utils.js.map